import React from "react";
import { IoChatboxEllipsesOutline } from "react-icons/io5";

function Chat() {
  return (
    <>
      <div className="chat">
        <IoChatboxEllipsesOutline size={"2rem"} />
        {/* <h1>Chat</h1> */}
      </div>
    </>
  );
}

export default Chat;
